import {
  gameChangerImportDataRequest,
  gameChangerImportDataSuccess,
  gameChangerImportDataFailure,
  getListGameChangerFilesRequest,
  getListGameChangerFilesSuccess,
  getListGameChangerFilesFailure,
} from '@actions/gameChanger';
import types from '@constants/action-types';
import { STATUS } from '@constants/status';
import { reducerFactory } from '@factories';

export const initialState = {
  isItemDeleting: [],
  isLoading: false,
  gameChangerFiles: {
    model: [],
    meta: {},
  },
  gameChangerOutputFiles: {},
  selectedOutputFiles: {
    isLoading: false,
    gameChangerOutputFiles: [],
    list: [],
  },
  error: null,
  amazonPullRequest: {
    isLoading: false,
  },
  amazonSellerRequestHistory: {
    isLoading: false,
  },
  runGameChanger: {
    isLoading: false,
  },
  viewRequests: {
    isLoading: false,
  },
  deleteGameChangerOutputFile: {},
  upload: {
    isLoading: false,
  },
  meta: {
    importDataStatus: STATUS.SUCCESS,
  },
};

export default reducerFactory(initialState, {
  [types.CLEAR_GAME_CHANGER_FILES]: state => ({
    ...state,
    amazonPullRequest: { isLoading: false },
  }),
  [types.DELETE_OUTPUT_FILE_REQUEST]: (state, { payload }) => ({
    ...state,
    isItemDeleting: [...state.isItemDeleting, ...payload.outputFiles],
  }),
  [types.DELETE_OUTPUT_FILE_SUCCESS]: (state, { response }) => ({
    ...state,
    isItemDeleting: state.isItemDeleting.filter(item => !response.outputFiles.includes(item)),
  }),
  [types.DELETE_OUTPUT_FILE_FAILURE]: (state, { response }) => ({
    ...state,
    isItemDeleting: state.isItemDeleting.filter(item => !response.outputFiles.includes(item)),
  }),
  [types.GET_LIST_GAME_CHANGER_OUTPUT_FILES_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [types.GET_LIST_GAME_CHANGER_OUTPUT_FILES_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    gameChangerOutputFiles: { ...response },
  }),
  [types.GET_LIST_GAME_CHANGER_OUTPUT_FILES_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
    gameChangerFiles: {},
    gameChangerOutputFiles: {},
  }),
  [types.GET_AMAZON_CENTRAL_TRANSACTIONS_REQUEST]: state => ({
    ...state,
    amazonPullRequest: { isLoading: true },
    error: null,
  }),
  [types.GET_AMAZON_CENTRAL_TRANSACTIONS_SUCCESS]: (state, { response }) => ({
    ...state,
    amazonPullRequest: {
      isLoading: false,
      ...response,
    },
  }),
  [types.GET_AMAZON_CENTRAL_TRANSACTIONS_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    amazonPullRequest: { error: response.error },
  }),
  [types.GET_AMAZON_SELLER_CENTRAL_REQUEST]: state => ({
    ...state,
    amazonSellerRequestHistory: { isLoading: true },
    error: null,
  }),
  [types.GET_AMAZON_SELLER_CENTRAL_SUCCESS]: (state, { response }) => ({
    ...state,
    amazonSellerRequestHistory: {
      isLoading: false,
      ...response,
    },
  }),
  [types.GET_AMAZON_SELLER_CENTRAL_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.RUN_GAME_CHANGER_REQUEST]: state => ({
    ...state,
    runGameChanger: { isLoading: true },
    error: null,
  }),
  [types.RUN_GAME_CHANGER_SUCCESS]: (state, { response }) => ({
    ...state,
    runGameChanger: {
      isLoading: false,
      ...response,
    },
  }),
  [types.RUN_GAME_CHANGER_FAILURE]: (state, { response }) => ({
    ...state,
    runGameChanger: {
      isLoading: false,
      ...response,
    },
  }),
  [types.GET_GAME_CHANGER_OUTPUT_REQUEST]: state => ({
    ...state,
    viewRequests: { isLoading: true },
    error: null,
  }),
  [types.GET_GAME_CHANGER_OUTPUT_SUCCESS]: (state, { response }) => ({
    ...state,
    viewRequests: {
      isLoading: false,
      ...response,
    },
  }),
  [types.GET_GAME_CHANGER_OUTPUT_FAILURE]: (state, { response }) => ({
    ...state,
    viewRequests: {
      isLoading: false,
      ...response,
    },
  }),
  [types.DELETE_GAME_CHANGER_OUTPUT_FILE_REQUEST]: state => ({
    ...state,
    deleteGameChangerOutputFile: { isLoading: true },
    error: null,
  }),
  [types.DELETE_GAME_CHANGER_OUTPUT_FILE_SUCCESS]: state => ({
    ...state,
    deleteGameChangerOutputFile: {
      isLoading: false,
      response: true,
    },
  }),
  [types.DELETE_GAME_CHANGER_OUTPUT_FILE_FAILURE]: state => ({
    ...state,
    deleteGameChangerOutputFile: {
      isLoading: false,
      response: false,
    },
  }),
  [types.GAME_CHANGER_OUTPUT_FILE_IDS_REQUEST]: state => ({
    ...state,
    selectedOutputFiles: { isLoading: true, list: [] },
    error: null,
  }),
  [types.GAME_CHANGER_OUTPUT_FILE_IDS_SUCCESS]: (state, { response }) => ({
    ...state,
    selectedOutputFiles: {
      isLoading: false,
      ...response,
    },
  }),
  [types.GAME_CHANGER_OUTPUT_FILE_IDS_FAILURE]: (state, { response }) => ({
    ...state,
    selectedOutputFiles: {
      isLoading: false,
      ...response,
    },
  }),
  [gameChangerImportDataRequest.type]: state => ({
    ...state,
    meta: {
      ...state.meta,
      importDataStatus: STATUS.LOADING,
    },
  }),
  [gameChangerImportDataSuccess.type]: state => ({
    ...state,
    meta: {
      ...state.meta,
      importDataStatus: STATUS.SUCCESS,
    },
  }),
  [gameChangerImportDataFailure.type]: state => ({
    ...state,
    meta: {
      ...state.meta,
      importDataStatus: STATUS.FAILURE,
    },
  }),
  [getListGameChangerFilesRequest.type]: state => ({
    ...state,
    gameChangerFiles: {
      ...state.gameChangerFiles,
      meta: {
        ...state.gameChangerFiles.meta,
        status: STATUS.LOADING,
      },
    },
  }),
  [getListGameChangerFilesSuccess.type]: (state, { payload }) => ({
    ...state,
    gameChangerFiles: {
      ...state.gameChangerFiles,
      model: payload.result.results,
      meta: {
        ...state.gameChangerFiles.meta,
        errorMessage: '',
        status: STATUS.SUCCESS,
        count: payload.result.count,
      },
    },
  }),
  [getListGameChangerFilesFailure.type]: (state, { payload }) => ({
    ...state,
    gameChangerOutputFiles: {},
    gameChangerFiles: {
      model: [],
      meta: {
        ...state.gameChangerFiles.meta,
        errorMessage: payload.errorMessage,
        status: STATUS.ERROR,
        count: 0,
      },
    },
  }),
});
